module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }